import { render } from "./LiveDwContent.vue?vue&type=template&id=7e133fa0"
import script from "./LiveDwContent.vue?vue&type=script&lang=js"
export * from "./LiveDwContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__